export const resumeLink =
  "https://docs.google.com/document/d/18fSpO-QdUdGEgf6kNCkW43lDKNpAA8MBJacdbSYZeSo/edit?usp=sharing";
